import { render, staticRenderFns } from "./AssetCondominiumObjectOverview.vue?vue&type=template&id=5f0486a8&scoped=true"
import script from "./AssetCondominiumObjectOverview.vue?vue&type=script&lang=js"
export * from "./AssetCondominiumObjectOverview.vue?vue&type=script&lang=js"
import style0 from "./AssetCondominiumObjectOverview.vue?vue&type=style&index=0&id=5f0486a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0486a8",
  null
  
)

export default component.exports